import { withAITracking } from '@microsoft/applicationinsights-react-js';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useProductCenterApi } from 'api';
import { userVisibilitySettingsQuery } from 'api/queries/UserSettingsQueries';
import { SearchProductForm } from 'library/components/controls/search/SearchForm/SearchProductForm';
import { getDeployAlertNotification } from 'library/redux/application';
import { useAppDispatch } from 'library/redux/hooks';
import { reactPlugin } from 'main/azureInsights/config';
import TitleWrapper from 'main/layout/TitleWrapper';
import { search_productUrl } from 'main/routes/urls/RouteUrls';
import HomeFooter from 'modules/Home/HomeFooter';
import 'modules/Home/assets/styles/HomeContent.scss';

import { getRandomBackgroundIndex } from './RandomBackground';

const backgroundHeight = 100;

const HomePage = (): React.JSX.Element => {
	const { t } = useTranslation(['home', 'searchProduct']);
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();
	const { api } = useProductCenterApi();

	useEffect(() => {
		void dispatch(getDeployAlertNotification());
		void queryClient.prefetchQuery({
			...userVisibilitySettingsQuery(api, 'SearchProductGrid'),
		});
	}, [dispatch, queryClient, api]);

	const navigate = useNavigate();

	const redirectToSearch = (data: string) => {
		navigate(search_productUrl + '/?by=' + data);
	};

	return (
		<>
			<TitleWrapper
				category={t('home:content-label')}
				title={t('home:content-subTitle')}
			/>
			<SearchProductForm
				sx={{ width: 1 }}
				onInputChange={redirectToSearch}
			/>
			<Box
				className={
					'homeContent homeContent--' + getRandomBackgroundIndex()
				}
				sx={{
					minHeight: backgroundHeight,
					flex: 1,
					display: 'flex',
				}}>
				<Box
					className="homeContent homeContent--overlay"
					sx={{
						display: 'flex',
						width: '100%',
					}}>
					<Box
						className="homeContent homeContent--gradient"
						sx={{
							width: '100%',
						}}
					/>
				</Box>
			</Box>
			<Grid
				container
				direction="row"
				sx={{
					mt: 2,
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				<HomeFooter />
			</Grid>
		</>
	);
};

export default withAITracking(
	reactPlugin,
	HomePage,
	'HomePage',
	'application-insight-container'
);
